import { render, staticRenderFns } from "./edit-access-permissions.vue?vue&type=template&id=2f82f472&scoped=true&"
import script from "./edit-access-permissions.vue?vue&type=script&lang=ts&"
export * from "./edit-access-permissions.vue?vue&type=script&lang=ts&"
import style0 from "./edit-access-permissions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./edit-access-permissions.vue?vue&type=style&index=1&id=2f82f472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82f472",
  null
  
)

export default component.exports